import { ICONS } from 'components/Icon';
import { Menu, MenuProps } from 'components/Menu';
import { CloudThumbnail } from 'components/Thumbnail/CloudThumbnail';
import { LocalThumbnail } from 'components/Thumbnail/LocalThumbnail';
import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { APIRemoteUrl } from 'service/api/constants';

interface Props {
  fileId: string;
  onPreview?: (fileId: string) => void;
  onDownload?: (fileId: string) => void;
  onRemove?: (fileId: string) => void;
  previewOnPress?: boolean;
  remoteUrl?: APIRemoteUrl;
}

export const ImageChip: React.FC<Props> = ({
  onPreview,
  onDownload,
  onRemove,
  previewOnPress = true,
  fileId,
  remoteUrl,
}: Props) => {
  const options: MenuProps['options'] = [];
  if (onPreview) {
    options.push({
      text: 'Preview',
      icon: ICONS.EyeLight,
      onPress: () => onPreview(fileId),
    });
  }
  if (onDownload) {
    options.push({
      text: Platform.OS === 'web' ? 'Download' : 'Share',
      icon: ICONS.ShareOS,
      onPress: () => onDownload(fileId),
    });
  }
  if (onRemove) {
    options.push({
      text: 'Remove',
      onPress: () => onRemove(fileId),
      destructive: true,
    });
  }
  return (
    <View style={{ height: '100%', width: '100%' }}>
      {remoteUrl ? (
        <CloudThumbnail
          imageUrl={remoteUrl(fileId)}
          width="100%"
          height="100%"
          rounded={false}
          onPress={
            previewOnPress && onPreview ? () => onPreview(fileId) : undefined
          }
        />
      ) : (
        <LocalThumbnail
          thumbnailId={fileId}
          width="100%"
          height="100%"
          rounded={false}
          onPress={
            previewOnPress && onPreview ? () => onPreview(fileId) : undefined
          }
        />
      )}
      {!!options.length && (
        <View style={styles.optionButtonContainer}>
          <Menu
            options={options}
            iconButtonConfig={{
              icon: ICONS.EllipsisLight,
              color: 'black',
              style: styles.optionButton,
            }}
          />
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  optionButton: {
    backgroundColor: 'rgba(255,255,255,0.64)',
  },
  optionButtonContainer: {
    position: 'absolute',
    right: 6,
    bottom: 6,
    zIndex: 1,
  },
});
